import React from 'react';
import styled from '@emotion/styled';
import { TagCloud as TagCloudComponent } from 'react-tagcloud';

const StyledTagCloud = styled.div`
  text-align: center;
`;

const TagCloud = ({
  minSize,
  maxSize,
  tags,
  onClick,
  renderer,
  className,
}: TagCloudProps) => (
  <StyledTagCloud {...(className && { className })}>
    <TagCloudComponent
      minSize={minSize}
      maxSize={maxSize}
      tags={tags}
      renderer={renderer}
      onClick={onClick}
      shuffle={false}
    />
  </StyledTagCloud>
);

export type TagCloudProps = {
  minSize: number;
  maxSize: number;
  tags: { value: string; count: number }[];
  renderer?: Function;
  onClick?: Function;
  className?: string;
};

export default TagCloud;
